<template>
  <section class="app__privacy">
    <div class="rules-link-block">
        <div class="control__privacy">
          <router-link
              :to="{ name: 'privacy' }"
              custom
              v-slot="{ href, navigate }"
          >
            <a
                :href="href"
                v-text="privacy"
                @click="showPopupIfPossible('privacy', $event, navigate)"
            />
          </router-link>
        </div>
        <div class="control__rules">
          <router-link
              :to="{ name: 'rules' }"
              custom
              v-slot="{ href, navigate }"
          >
            <a
                :href="href"
                @click="showPopupIfPossible('rules', $event, navigate)"
            >Правила проведения информационной кампании в рамках организации мероприятия «Итоги года <nobr>с Владимиром Путиным</nobr>»</a>
          </router-link>
        </div>
    </div>
  </section>
</template>

<script>
import {mapActions} from "vuex";

export default {
  methods:  {
    ...mapActions([
      'showPopup'
    ]),
    showPopupIfPossible(page, event, navigate) {
      const isMobile = window.matchMedia('(max-width: 767px)').matches;

      if (isMobile) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        this.showPopup({ type: true, page });
      } else if (typeof navigate === 'function') {
        navigate(event);
      }
    }
  },
  data() {
    return {
      privacy: 'Условия обработки персональных данных'
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/config";

  .app__privacy {
    position: absolute;
    bottom: 90px;
    left: 40px;
    z-index: 2;
    width: 20%;

    @media screen and ($media-desktop) {
      box-sizing: border-box;
      width: 100%;
      position: relative;
      bottom: auto;
      left: auto;
      order: 1;
      margin: 0 $grid-gutter-page 40px;
    }

    @media screen and ($media-mobile) {
      margin: 0 12px 50px 12px;
    }

    .rules-link-block {
      z-index: 1;

      a {
        font-family: 'GolosText';
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        color: rgba($color-black, .8);
      }

    }

  }

  .app__privacy:has(+ .app__content.app__content--active) {
    display: none;
  }

</style>